import { Permissions } from '@/ui/auth/auth.types';
import { computed, VNode } from 'vue';
import { hasPermission, hasSomePermission } from '@/ui/auth/auth';
import { LoggedInUser } from '@/entities/auth/loggedInUser';
import { TrialStatus } from '@/entities/organization/constants';

export const isSubscriptionFree = (user: LoggedInUser) => {
  return user.subscription && user.subscription.isFree;
};

export const isSubscriptionEnterprise = (user: LoggedInUser) => {
  return user.subscription && user.subscription.isEnterprise;
};

const isLegacySubscriptionFree = (user: LoggedInUser) => {
  return user._legacy_subscription && user._legacy_subscription.plan.is_free;
};

export const userHasFreePlan = (user: LoggedInUser) => {
  return isSubscriptionFree(user) || isLegacySubscriptionFree(user);
};

export const whenUserIsOnFreeTrialPlan = (user: LoggedInUser, item: VNode) => (
  user.organization.trialStatus === TrialStatus.FREE_TRIAL_STATUS_CURRENT ? [item] : []
);

export const canIndexChecklists = computed(
  () => hasSomePermission([Permissions.MANAGE_CHECKLISTS, Permissions.CONDUCT_OPEN_INSPECTIONS]),
);

export const canIndexSchedules = computed(
  () => hasSomePermission([Permissions.MANAGE_CHECKLISTS]),
);

export const canViewInspections = computed(
  () => hasPermission(Permissions.VIEW_ALL_INSPECTION),
);

export const isFirstOrganizationUser = (user: LoggedInUser) => {
  return user.organization.firstUserId === user.id;
};
